@if (isLoading()) {
    <div class="spinner">
        <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
} @else {
    <!-- Issue Body -->
    <div class="issue">
        <div class="issue-header">
            <div class="issue-header-title">
                <!-- <img class="icon" [src]="./assets/mockData/icons/issue-sidePanel.svg"/> -->
                <div class="issue-header-title-text" style="display: flex" appLongTextTooltip>
                    {{ issueModel.name }}
                </div>
            </div>

            <div class="issue-header-secondary-title">
                <div class="issue-header-secondary-title-property">Issue</div>
            </div>

            <app-sidepanel-tabs class="issue-header-tabs" [tabs]="tabs" (tabOnSelection)="onTabSelect($event)"> </app-sidepanel-tabs>
        </div>

        <div class="issue-actions">
            @if (isLoading()) {
                <mat-progress-spinner class="small-spinner" color="primary" mode="indeterminate" style="left: -20px"> </mat-progress-spinner>
            }
            <div class="actions">
                <app-single-page-actions class="actions" [menuActions]= "menuActions() || []" (actionSelected)="actionSelected($event)">
                </app-single-page-actions>
            </div>
        </div>

        <div class="issue-body">
            <!-- Overview Tab -->
            @if (activeTabIndex === 0) {
                <div class="issue-body-tab">
                    <div class="issue-body-tab-card issue-details-card">
                        <div class="issue-body-content">
                            <div class="issue-analysis">
                                <div class="issue-body-tab-card-title">
                                    {{ "issuesPage.issueAnalysis" | labelsProvider }}
                                </div>
                                <div>
                                    {{ issueModel.issueAnalysis }}
                                </div>
                            </div>
                            <!-- Vertical Separator -->
                            <div class="vertical-separator"></div>

                            <div class="issue-body-details">
                                <div class="details-item">
                                    Status
                                    <app-status-label [statusLabel]="issueModel.status"/>
                                </div>
                                <div class="details-item">
                                    Severity <app-severity-label [severity]="issueModel.severity" [smallSize]="true"/>
                                </div>
                                <div class="details-item">CVSS Score {{ issueModel.cvssScore }}</div>
                                <div class="details-item">
                                    Business criticality
                                    <app-severity-label [severity]="issueModel.businessCriticality" [smallSize]="true"/>
                                </div>
                                <div class="details-item-first-seen">
                                    <div>First activity</div>
                                    <div>{{ issueModel.firstActivity }}</div>
                                </div>
                                <div class="details-item-last-seen">
                                    <div>Last activity</div>
                                    <div>{{ issueModel.lastActivity }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="issue-body-tab-card issue-details-card">
                        <app-relations-graph [integrationId]="integrationId" [resourceId]="issue()" [isIssueComponent]="true"/>
                    </div>

                    <div class="issue-body-tab-card issue-details-card">
                        <div class="issue-body-tab-card-title">
                            {{ "issuesPage.issueTimeLine" | labelsProvider }}
                        </div>
                        <app-timeline-issue [timelineIssueItems]="timelineItems"></app-timeline-issue>
                        <div></div>
                    </div>

                    <div class="issue-body-tab-card issue-details-card">
                        <div class="issue-body-tab-card-title">
                            Frameworks

                            <div class="issue-body-tab-card-title-subtitle">
                                @for (framework of frameworks | keyvalue; track framework.key) {
                                    <div class="framework-container">
                                        <div class="framework-title">{{ framework.key | replaceUnderscore }}</div>
                                        <span class="framework-items">
                                            @for (item of framework.value; track item) {
                                                <span class="framework-item">{{ item }}</span>
                                            }
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="issue-body-tab-card issue-details-card">
                        <!--Findings-->
                        <app-issue-findings [finding]="issueModel.relatedFindings"/>
                    </div>
                </div>
            }

            @if (activeTabIndex === 1) {
                <!-- Remediation Tab -->
                <div class="issue-body-tab remediation-tab">
                    <div class="issue-body">
                        <div class="issue-body-tab-card issue-details-card">
                            <div>
                                @for (task of issueRemediations; track task; let i = $index) {
                                    <div class="issue-body-tab-card-title response-section">
                                        <h5>{{ i + 1 }}. {{ task?.title }}</h5>
                                        <ul>
                                            @for (instruction of task.instructions; track instruction) {
                                                <li>{{ instruction }}</li>
                                            }
                                        </ul>
                                        @if (task.buttonText) {
                                            <button class="btn" [ngClass]="task.buttonClass" (click)="actionClicked(task.buttonText)">
                                                {{ task.buttonText }}
                                            </button>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
}
